import { getCookie } from '@cookies'
import { trackFormSubmission } from '@helpers'
import { makeStyles } from '@material-ui/styles'

export function mktoTrialSignup(form, location = 'us') {
  const UX1Countries = ['US', 'MX', 'IN']
  const changeEvent = new Event('change')
  const regionDisplayNames = new Intl.DisplayNames(['en'], { type: 'region' })
  const geoCookieValue = getCookie('OPTOUTMULTI_GEO')
  // Get form els
  const impliedConsentMessage = document.querySelector('#impliedConsent')
  const countryInput = document.querySelector("input[name='Country']")
  const countryInputValue = regionDisplayNames.of(geoCookieValue)

  console.log('BUILD TRIAL FORM: location: ' + location)

  if (countryInputValue) {
    countryInput.value = countryInputValue
    countryInput.dispatchEvent(changeEvent)
    if (UX1Countries.includes(geoCookieValue)) {
      impliedConsentMessage.style.visibility = 'visible'
    }
    console.log('BUILD TRIAL FORM: Detected language:' + countryInputValue)
  } else {
    const companyDetails = JSON.parse(
      window.localStorage.getItem('_6senseCompanyDetails')
    )
    impliedConsentMessage.style.visibility = 'visible'
    console.log(
      companyDetails
        ? 'BUILD TRIAL FORM: Unable to pull country'
        : 'BUILD TRIAL FORM: 6sense not found'
    )
  }

  const tosInput = document.querySelector("input[name='optinDataCollection']")
  const submitButton = document.querySelector("button[type='submit']")

  if (tosInput && submitButton) {
    // TOS checkbox exists, manage submit button state based on it
    submitButton.disabled = true
    tosInput.addEventListener('change', (event) => {
      submitButton.disabled = !event.target.checked
    })
  } else if (submitButton) {
    // No TOS checkbox exists (normal for trial flows), keep submit button enabled
    submitButton.disabled = false
  }

  // Set up data center region validation
  const dataCenterRegionSelect = document.getElementById('data-center-region')
  if (dataCenterRegionSelect) {
    // Clear errors when user selects a region
    dataCenterRegionSelect.addEventListener('change', function (e) {
      e.stopPropagation() // Prevent form-level interference

      if (this.value && this.value !== '') {
        // Clear error styling and message
        this.style.border = ''
        const errorMsg = document.getElementById('data-center-region-error')
        if (errorMsg) {
          errorMsg.remove()
        }

        // Re-enable submit button if it was disabled due to validation
        if (submitButton && (!tosInput || tosInput.checked)) {
          submitButton.disabled = false
        }
      }
    })
  }

  // Add reliable validation using submit button click handler that runs first
  if (submitButton && dataCenterRegionSelect) {
    submitButton.addEventListener(
      'click',
      function (e) {
        // Check our custom validation first, before any other handlers
        if (
          !dataCenterRegionSelect.value ||
          dataCenterRegionSelect.value === ''
        ) {
          // Prevent the submit from happening
          e.preventDefault()
          e.stopImmediatePropagation()

          // Show error styling
          dataCenterRegionSelect.style.border = '2px solid #ff4444'
          dataCenterRegionSelect.focus()

          // Add error message if it doesn't exist
          let errorMessage = document.getElementById('data-center-region-error')
          if (!errorMessage) {
            errorMessage = document.createElement('div')
            errorMessage.id = 'data-center-region-error'
            errorMessage.style.color = '#ff4444'
            errorMessage.style.fontSize = '14px'
            errorMessage.style.marginTop = '4px'
            errorMessage.textContent =
              'Please select a data center region to continue.'
            dataCenterRegionSelect.parentNode.appendChild(errorMessage)
          }

          return false
        }
        // If region is selected, let Marketo handle the rest (including email validation)
      },
      true
    ) // Use capture phase to run before other handlers
  }

  // Track form submission only after successful validation
  form.onSubmit(function () {
    const vals = form.vals()
    const dataProduct = vals.dataProduct || 'generic'
    trackFormSubmission(vals.formid, dataProduct)
  })

  form.onSuccess(function (values, _followUpUrl) {
    const form = document.createElement('form')
    form.setAttribute(
      'action',
      'https://acc-trials.autodesk.com/trial-signup/i/lookup/index.php'
    )
    form.setAttribute('method', 'POST')
    form.setAttribute('id', 'dataHiddenForm')

    const input1 = document.createElement('input')
    input1.type = 'hidden'
    input1.name = 'email'
    input1.value = values.Email
    form.appendChild(input1)

    const input2 = document.createElement('input')
    input2.type = 'hidden'
    input2.name = 'company'
    input2.value = values.Company
    form.appendChild(input2)

    const input3 = document.createElement('input')
    input3.type = 'hidden'
    input3.name = 'phone'
    input3.value = values.Phone
    form.appendChild(input3)

    const regionInputValue = document
      .getElementById('TrialUxExternal')
      .getAttribute('data-region')

    if (regionInputValue) {
      const input4 = document.createElement('input')
      input4.type = 'hidden'
      input4.name = 'region'
      input4.value = regionInputValue
      form.appendChild(input4)
    }

    document.body.appendChild(form)
    document.getElementById('dataHiddenForm').submit()

    return false
  })
}

export const mktoTrialSignupStyles = makeStyles((theme) => ({
  form: {
    '& .mktoForm': {
      color: 'inherit !important',
      fontFamily: 'inherit !important',
      width: '100% !important',
      '& input': {
        fontSize: 'inherit !important',
      },
      '& select': {
        height: '38px',
        padding: '0 14px',
        borderRadius: '4px',
        appearance: 'none',
        backgroundImage: `url(
          'data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'
        )`,
        backgroundRepeat: 'no-repeat, repeat',
        backgroundPosition: 'right .7em top 50%, 0 0',
        backgroundSize: '.65em auto, 100%',
      },
    },
    '& a': {
      borderBottom: `1px dashed ${theme.palette.text.matterhorn}`,
      color: theme.palette.text.matterhorn,
      display: 'inline',
      padding: '0 !important',
      textDecoration: 'none',
      textTransform: 'none',
    },
    '& .mktoFormRow': {
      '&:nth-of-type(2)': {
        display: 'none',
      },
      '& .mktoFormCol': {
        marginBottom: '16px !important',
        minHeight: 'unset !important',
        width: '100%',
      },
    },
    '& .mktoFormRow.fullWidthRow': { width: '100%' },
    '& .mktoLabel': {
      color: theme.palette.text.font,
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: '10px',
      width: '100% !important',
    },
    '& .mktoOffset': { display: 'none !important' },
    '& .mktoGutter': { display: 'none !important' },
    '& .mktoAsterix': { display: 'none !important' },
    '& #LbloptinMarketingCommunications': { display: 'none' },
    '& #LbloptinDataCollection': { display: 'none' },
    '& .mktoFieldWrap': {
      display: 'flex',
      flexDirection: 'column',
      float: 'none !important',
    },
    '& .mktoTextField': {
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: '4px',
      height: '38px !important',
      padding: '0px 14px !important',
      width: '100% !important',
      '&:focus': {
        backgroundColor: 'none',
        boxShadow: `0px 0px 0px 1px ${theme.palette.primary.main}`,
        outline: 'none',
      },
    },
    '& .mktoCheckboxList': {
      fontSize: '13px',
      padding: '0 !important',
      width: '100% !important',
      '& input': {
        marginTop: '2px',
        float: 'left',
      },
      '& label': {
        lineHeight: 'inherit',
        marginBottom: '0 !important',
      },
    },
    '& .mktoButtonRow': {
      display: 'block',
      '& .mktoButtonWrap': {
        display: 'block',
        margin: '4px 0 16px 0 !important',
        '& button': {
          backgroundColor: `${theme.palette.primary.main} !important`,
          backgroundImage: 'none !important',
          border: 'none !important',
          borderRadius: '4px',
          color: `theme.palette.primary.contrastText !imporant`,
          fontSize: '15px !important',
          fontWeight: '700',
          letterSpacing: '-0.18px',
          minHeight: '45px',
          minWidth: '150px',
          padding: '8px 12px',
          textTransform: 'uppercase',
          width: '100%',
        },
      },
    },
  },
}))
